import {DeviceType} from '../incase-domain/common/DeviceType.enum';
import {IRunFile} from '../incase-domain/proptypes/runfile';
import {ISlide} from '../incase-domain/slide';

export function presCustomVarsParser(text: string, runfile: IRunFile): string {
    const regex = /{{(.*?)}}/g;
    const {customVars} = runfile;

    if (!customVars) return text;

    return text.replace(regex, (match, varName): string => {
        if (customVars[`${varName}`]) {
            return `${customVars[varName]}`;
        }
        return match;
    });
}

export function filterSlideTypes(slides: ISlide[], deviceTypes: DeviceType[]): ISlide[] {
    return slides.filter((slide) => deviceTypes.includes(slide.deviceType ?? DeviceType.ALL));
}
